import {
  Component,
  OnInit,
  ViewChild,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MasterHomeCreateProfileService } from '../../service/master-home-create-profile.service';
@Component({
  selector: 'table-confirm-users',
  templateUrl: './table-confirm-users.component.html',
  styleUrls: ['./table-confirm-users.component.scss'],
})
export class TableConfirmUsers implements OnInit {
  constructor(
    private serviceHomeCreateProfile: MasterHomeCreateProfileService,
  ) {}
  dataTableInfo: any;
  allChecked: boolean = false;
  dataTableFilter: any;

  @ViewChild('sort', { static: false }) sort: MatSort;
  @Input() dataTable: Array<any>;
  @Input() dataRetrieveNode: string;
  @Output() rolesSelected: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    this.getDataTable();
    this.dataTableInfo.sort = this.sort;
  }

  ngAfterViewInit() {
    this.dataTableInfo.sort = this.sort;
  }

  getDataTable() {
    this.dataTable.forEach(data => {
      if (!data.checked) {
        return (data.checked = false);
      }
    });
    let dataTable = this.dataTableInfo;
    dataTable.sort((a, b) => {
      if (a.name === null) {
        a.name = '';
      }
      if (b.name === null) {
        b.name = '';
      }
      return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
    })
    this.dataTableInfo = new MatTableDataSource(dataTable);

    this.dataTableInfo.sort = this.sort;
    this.isAllSelected();
  }

  filterDataTableInput(event) {
    this.dataTableFilter = (event.target as HTMLInputElement).value;
    this.dataTableInfo.filter = this.dataTableFilter;
  }

  toogleAllSelected() {
    this.allChecked = !this.allChecked;
    this.dataTableInfo.data.forEach(row => (row.checked = this.allChecked));
    this.onSelectRole();
  }

  isAllSelected() {
    this.allChecked = this.dataTableInfo.data.every(row => row.checked == true);
    this.onSelectRole();
  }

  toggleSelection(row) {
    this.dataTableInfo.data.forEach(data => {
      if (row.id === data.id) {
        row.checked = !row.checked;
      }
    });
    this.isAllSelected();
    this.onSelectRole();
  }

  someComplete() {
    return this.dataTableInfo.data.some(ele => ele.checked == true);
  }

  onSelectRole() {
    this.serviceHomeCreateProfile.setRoles(
      this.dataTableInfo.data,
      this.dataRetrieveNode,
    );
    this.rolesSelected.emit(this.dataTableInfo.data);
  }
}
